import React from 'react';

export interface PrivateIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

export const PrivateIcon: React.FC<PrivateIconProps> = ({
  width = 24,
  height = 24,
  color = '#6DA6B9',
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-label='Private'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.47949 5.06543L12 2L21 7V17L19.3369 17.9229L22.707 21.293L21.293 22.707L1.29297 2.70703L2.70703 1.29297L6.47949 5.06543ZM7.9502 6.53613L9.41406 8H13.9141L15.5 9.58594V12.6182L14.5215 13.1074L17.8662 16.4521L19 15.8232V8.17676L12 4.28711L7.9502 6.53613ZM12.9141 11.5H13.2637L13.5 11.3818V10.4141L13.0859 10H11.4141L12.9141 11.5Z'
        fill={color}
      />
      <path
        d='M5 9.16406V15.8232L12 19.7119L14.2803 18.4443L15.751 19.915L12 22L3 17V7.16406L5 9.16406Z'
        fill={color}
      />
      <path d='M11 15.1641V16H9V13.1641L11 15.1641Z' fill={color} />
    </svg>
  );
};
